import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, ViewStyle} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    container: {
      backgroundColor: props.colors.purple(0.13),
      borderRadius: 8,
      marginTop: 15,
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-start',
      height: 40,
      marginLeft: 16,
      paddingRight: 6,
    },
    image: {
      width: 13,
      height: 13,
      marginRight: 5,
      marginLeft: 10,
    },
  });
